module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('div', [_c('v-btn', {
    on: {
      "click": _vm.exportUserData
    }
  }, [_vm._v("Export Users")])], 1), _vm._v(" "), _c('div', {
    staticClass: "users-filter-set"
  }, [_c('user-search-input', {
    on: {
      "query-updated": _vm.handleNameQueryUpdated
    }
  }), _vm._v(" "), _c('user-group-selector', {
    on: {
      "groups-selected": _vm.handleGroupsSelected
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "rows-per-page-items": [10, 5, {
        text: "Test",
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user_groups))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.valid_records_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.all_records_amt))]), _vm._v(" "), _c('td', [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.buildDetailsLink(props.item.id)
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t('user.view')) + "\n        ")])], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-463fa1b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UsersList.vue
// module id = 1036
// module chunks = 1